var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoa",
    x1: 14.47,
    x2: 35.54,
    y1: 5.56,
    y2: 46.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ecfcef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c2f3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b5d9f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOob",
    x1: 14.63,
    x2: 35.34,
    y1: 5.87,
    y2: 45.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e8fbeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b4f0d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#a4d1f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoc",
    x1: 14.79,
    x2: 35.15,
    y1: 6.18,
    y2: 45.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e4fae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#a7eecb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#94c8f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOod",
    x1: 14.95,
    x2: 34.96,
    y1: 6.48,
    y2: 45.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dffae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#99ebc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#83c0f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoe",
    x1: 15.11,
    x2: 34.76,
    y1: 6.79,
    y2: 44.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dbf9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#8ce8bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#73b8f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOof",
    x1: 15.27,
    x2: 34.57,
    y1: 7.1,
    y2: 44.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#d7f8dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#7ee6b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#62afef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOog",
    x1: 15.42,
    x2: 34.38,
    y1: 7.41,
    y2: 44.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#d3f7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#71e3ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#52a7ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoh",
    x1: 15.58,
    x2: 34.19,
    y1: 7.71,
    y2: 43.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cef7d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#63e0a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#419feb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoi",
    x1: 15.74,
    x2: 33.99,
    y1: 8.02,
    y2: 43.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#caf6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#56de9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3196ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoj",
    x1: 15.9,
    x2: 33.8,
    y1: 8.33,
    y2: 42.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c6f5ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#48db94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#208ee8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOok",
    x1: 23.21,
    x2: 29.4,
    y1: 19.96,
    y2: 26.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#effcf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1ffe9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOol",
    x1: 23.61,
    x2: 29.3,
    y1: 20.4,
    y2: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecfbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e7fced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9ffe5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOom",
    x1: 24,
    x2: 29.2,
    y1: 20.82,
    y2: 26.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9fbec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5fceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2ffe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOon",
    x1: 24.37,
    x2: 29.1,
    y1: 21.22,
    y2: 26.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7faea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e3fbe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#baffde"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoo",
    x1: 24.73,
    x2: 29,
    y1: 21.6,
    y2: 26.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4fae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e1fae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2ffda"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOop",
    x1: 25.07,
    x2: 28.9,
    y1: 21.95,
    y2: 25.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1f9e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#defae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abffd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOoq",
    x1: 25.39,
    x2: 28.8,
    y1: 22.29,
    y2: 25.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#def9e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#dcf9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3ffd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOor",
    x1: 25.7,
    x2: 28.7,
    y1: 22.61,
    y2: 25.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcf8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#daf8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9bffcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOos",
    x1: 25.99,
    x2: 28.6,
    y1: 22.91,
    y2: 25.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9f8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d8f8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94ffcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9DhbRDCsY0CrrBMv9xGOot",
    x1: 26.27,
    x2: 28.5,
    y1: 23.2,
    y2: 25.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d6f7dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8cffc7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoa)",
    d: "m44,24c0,11.04-8.96,20-20,20S4,35.04,4,24,12.95,4,24,4s20,8.95,20,20Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.67,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOob)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.33,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoc)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOod)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18.67,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoe)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18.33,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOof)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOog)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17.67,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoh)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17.33,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoi)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17,
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoj)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOok)",
    d: "m22.58,31.88c-.65,0-1.3-.25-1.79-.74l-5.05-5.05c-.99-.99-.99-2.59,0-3.58.99-.99,2.59-.99,3.58,0l3.26,3.26,8.09-8.09c.99-.99,2.59-.99,3.58,0,.99.99.99,2.59,0,3.58l-9.88,9.88c-.49.49-1.14.74-1.79.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOol)",
    d: "m22.58,31.74c-.61,0-1.22-.23-1.69-.7l-5.05-5.05c-.93-.93-.93-2.45,0-3.38.93-.93,2.45-.93,3.38,0l3.36,3.36,8.19-8.19c.93-.93,2.45-.93,3.38,0,.93.93.93,2.45,0,3.38l-9.88,9.88c-.47.47-1.08.7-1.69.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOom)",
    d: "m22.58,31.6c-.58,0-1.15-.22-1.59-.66l-5.05-5.05c-.88-.88-.88-2.3,0-3.18.88-.88,2.3-.88,3.18,0l3.46,3.46,8.29-8.29c.88-.88,2.31-.88,3.18,0,.88.88.88,2.31,0,3.18l-9.88,9.88c-.44.44-1.02.66-1.59.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOon)",
    d: "m22.58,31.46c-.54,0-1.08-.21-1.49-.62l-5.06-5.06c-.82-.82-.82-2.16,0-2.99.82-.82,2.16-.82,2.99,0l3.56,3.56,8.39-8.39c.82-.82,2.16-.82,2.99,0,.82.82.82,2.16,0,2.99l-9.88,9.88c-.41.41-.95.62-1.49.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoo)",
    d: "m22.58,31.32c-.5,0-1.01-.19-1.39-.58l-5.06-5.06c-.77-.77-.77-2.02,0-2.79.77-.77,2.02-.77,2.79,0l3.66,3.66,8.49-8.49c.77-.77,2.02-.77,2.79,0,.77.77.77,2.02,0,2.79l-9.88,9.88c-.38.38-.89.58-1.39.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOop)",
    d: "m22.58,31.18c-.47,0-.94-.18-1.29-.54l-5.06-5.06c-.71-.71-.71-1.87,0-2.59.71-.71,1.87-.71,2.59,0l3.77,3.77,8.59-8.59c.71-.71,1.87-.71,2.59,0,.71.71.71,1.87,0,2.59l-9.88,9.88c-.36.36-.83.54-1.29.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOoq)",
    d: "m22.58,31.04c-.43,0-.86-.16-1.19-.49l-5.06-5.06c-.66-.66-.66-1.73,0-2.39.66-.66,1.73-.66,2.39,0l3.87,3.87,8.69-8.69c.66-.66,1.73-.66,2.39,0,.66.66.66,1.73,0,2.39l-9.88,9.88c-.33.33-.76.49-1.19.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOor)",
    d: "m22.58,30.9c-.4,0-.79-.15-1.09-.45l-5.06-5.06c-.6-.6-.6-1.58,0-2.19.6-.6,1.58-.6,2.19,0l3.97,3.97,8.79-8.79c.6-.6,1.58-.6,2.19,0,.6.6.6,1.58,0,2.19l-9.88,9.88c-.3.3-.7.45-1.09.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOos)",
    d: "m22.59,30.76c-.36,0-.72-.14-1-.41l-5.06-5.06c-.55-.55-.55-1.44,0-1.99.55-.55,1.44-.55,1.99,0l4.07,4.07,8.89-8.89c.55-.55,1.44-.55,1.99,0,.55.55.55,1.44,0,1.99l-9.88,9.88c-.27.27-.64.41-1,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9DhbRDCsY0CrrBMv9xGOot)",
    d: "m22.59,30.62c-.32,0-.65-.12-.9-.37l-5.07-5.07c-.49-.49-.49-1.3,0-1.79s1.3-.49,1.79,0l4.17,4.17,8.99-8.99c.49-.49,1.3-.49,1.79,0s.49,1.3,0,1.79l-9.88,9.88c-.25.25-.57.37-.9.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.0e54108cc6f054927a804f6dc8db5319.svg";
export { ForwardRef as ReactComponent };